export interface TooltipConfiguration {
  placement: string;
  effect: string;
}

export const tooltipDefaultConfiguration: TooltipConfiguration = {
  placement: 'bottom',
  effect: 'light',
};
